import {WalletAdapter} from "@/api/wallets";
import BN from "bn.js";
import {Detail, Reserve} from "@/api/models";
import {Account, Connection, PublicKey, TransactionInstruction} from "@solana/web3.js";
import {LENDING_PROGRAM_ID} from "@/api/utils/ids";
import {createWithdrawMiningInstruction} from "@/api/models/instructions/withdrawMining";

export const withdrawMining = async (
    connection:Connection,
    signers: Account[],
    instructions: TransactionInstruction[],
    cleanupInstructions: TransactionInstruction[],
    mining:PublicKey,
    destinationAccount:PublicKey,
    reserve:Detail<Reserve>,
    withdrawAmount:BN,
    wallet:WalletAdapter,
    lendingMarket:PublicKey,

) => {
    if (wallet.publicKey == null){
        throw new Error("wallet need connection")
    }
    const [lendingMarketAuthority] = await PublicKey.findProgramAddress(
        [lendingMarket.toBuffer()],
        LENDING_PROGRAM_ID,
    );
    instructions.push(createWithdrawMiningInstruction(
        mining,
        withdrawAmount,
        destinationAccount,
        reserve,
        lendingMarket,
        lendingMarketAuthority,
        wallet.publicKey
    ))
}